// extracted by mini-css-extract-plugin
export var avatar = "_r9-3";
export var avatarContainer = "_r9-2";
export var avatarSpacer = "_r9-5";
export var avatarSpacerContainer = "_r9-4";
export var avatarStackContainer = "_r9-1";
export var bubble = "_r9-0";
export var remainderBubble = "_r9-6";